import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, UserCheck } from "lucide-react";
import api from "@/lib/api";

export default function CollectionAssignDialog({ open, row, onClose, onSaved }) {
  const [users, setUsers] = useState([]);
  const [scope, setScope] = useState("invoice"); // invoice | project
  const [pic, setPic] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/users").then(({ data }) => setUsers(Array.isArray(data) ? data : (data.items || []))).catch(() => {});
    setPic(row?.pic_collection_id || "");
  }, [open, row]);

  if (!open || !row) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!pic) { toast.error("Pilih PIC"); return; }
    setSaving(true);
    try {
      await api.post("/collection/assignments", {
        project_id: row.project_id,
        entry_id: scope === "invoice" ? row.entry_id : null,
        pic_id: pic,
        note,
      });
      toast.success("PIC ter-assign");
      onSaved();
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal"); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" data-testid="assign-dialog">
      <div className="bg-white w-full max-w-md">
        <div className="bg-[#0B1D3A] text-white px-4 py-3 flex items-center justify-between">
          <h3 className="font-display font-bold flex items-center gap-2"><UserCheck size={16} /> Assign PIC Collection</h3>
          <button onClick={onClose} className="text-white/70 hover:text-white"><X size={18} /></button>
        </div>
        <form onSubmit={submit} className="p-4 space-y-3">
          <div className="text-xs text-slate-600">{row.client} · {row.project_name}</div>
          <div>
            <label className="block text-[10px] uppercase tracking-wider text-slate-500 mb-1 font-semibold">Scope</label>
            <div className="grid grid-cols-2 gap-1">
              <button type="button" data-testid="assign-scope-invoice"
                onClick={() => setScope("invoice")}
                className={`px-2 py-2 text-xs uppercase tracking-wider font-semibold ${scope === "invoice" ? "bg-[#FF5A1F] text-white" : "bg-white border border-slate-300 text-slate-600 hover:bg-slate-50"}`}>
                Per Invoice
              </button>
              <button type="button" data-testid="assign-scope-project"
                onClick={() => setScope("project")}
                className={`px-2 py-2 text-xs uppercase tracking-wider font-semibold ${scope === "project" ? "bg-[#FF5A1F] text-white" : "bg-white border border-slate-300 text-slate-600 hover:bg-slate-50"}`}>
                Seluruh Project
              </button>
            </div>
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-wider text-slate-500 mb-1 font-semibold">PIC *</label>
            <select required data-testid="select-assign-pic" value={pic} onChange={(e) => setPic(e.target.value)}
              className="w-full border border-slate-300 px-3 py-2 text-sm">
              <option value="">— Pilih user —</option>
              {users.map((u) => <option key={u.id} value={u.id}>{u.name} · {u.division} Lv{u.level}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-wider text-slate-500 mb-1 font-semibold">Catatan</label>
            <input type="text" value={note} onChange={(e) => setNote(e.target.value)}
              className="w-full border border-slate-300 px-3 py-2 text-sm" />
          </div>
          <div className="flex justify-end gap-2 pt-2 border-t border-slate-200">
            <button type="button" onClick={onClose} className="px-4 py-2 text-xs uppercase tracking-wider border border-slate-300">Batal</button>
            <button type="submit" data-testid="btn-save-assign" disabled={saving}
              className="px-4 py-2 text-xs uppercase tracking-wider bg-[#FF5A1F] hover:bg-[#e04d15] text-white disabled:opacity-50">
              {saving ? "Menyimpan..." : "Simpan Assignment"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
